import * as ko from "knockout";
import {IExportTemplate} from "../../../index";
import {isSyncTemplateNameValidForCopyWizard} from "../../ruleset/copy-wizard/copyWizardStrictNames";

/**
 * Name + target collision state for one synchronization template row in
 * {@link component/export-template/copy-wizard/main.ts}.
 */
export class SyncTemplateNameConflictRowVm {
    readonly hadConflictInitially: boolean;
    readonly hadInitialBatchDuplicateName: boolean;
    readonly draftName: KnockoutObservable<string>;

    constructor(
        readonly template: IExportTemplate,
        private readonly getTargetTemplates: () => IExportTemplate[],
        private readonly getOtherDraftNames: () => string[],
        hadInitialBatchDuplicateName: boolean,
    ) {
        this.draftName = ko.observable(template.name);
        const sourceNameTrimmed = template.name.trim();
        this.hadConflictInitially = this.getTargetTemplates().some(
            (t) => t.name.trim() === sourceNameTrimmed,
        );
        this.hadInitialBatchDuplicateName = hadInitialBatchDuplicateName;
    }

    readonly conflictTarget = ko.pureComputed((): IExportTemplate | null => {
        const trimmed = this.draftName().trim();
        return this.getTargetTemplates().find((t) => t.name.trim() === trimmed) ?? null;
    });

    readonly hasFormatViolation = ko.pureComputed((): boolean => {
        const trimmed = this.draftName().trim();
        if (!trimmed) {
            return false;
        }
        return !isSyncTemplateNameValidForCopyWizard(trimmed);
    });

    readonly hasBlockingConflict = ko.pureComputed((): boolean => {
        const my = this.draftName().trim();
        if (!my) {
            return true;
        }
        if (!isSyncTemplateNameValidForCopyWizard(my)) {
            return true;
        }
        if (this.getTargetTemplates().some((t) => t.name.trim() === my)) {
            return true;
        }
        return this.getOtherDraftNames().includes(my);
    });

    readonly badgeState = ko.pureComputed((): "conflict" | "noconflict" =>
        this.hasBlockingConflict() ? "conflict" : "noconflict",
    );

    readonly showNameInput = ko.pureComputed(
        () =>
            this.hasBlockingConflict() ||
            this.hadConflictInitially ||
            this.hadInitialBatchDuplicateName ||
            this.hasFormatViolation(),
    );
}
